module.exports = __webpack_public_path__ + "static/026-fbc76a54decadc84f031555da89151e7.jpg";